import galvanlondonLogo from './images/brand-logos/galvanlondon.svg';
import odloLogo from './images/brand-logos/odlo.svg';
import lesdeuxLogo from './images/brand-logos/lesdeux.svg';
import holzweilerLogo from './images/brand-logos/holzweiler.svg';
import seaLogo from './images/brand-logos/sea.svg';
import malenaLogo from './images/brand-logos/malena.svg';
import pasnormalLogo from './images/brand-logos/pasnormal.svg';
import cycologyLogo from './images/brand-logos/cycology.svg';
import bonaparteLogo from './images/brand-logos/bonaparte.svg';
import assosLogo from './images/brand-logos/assos.svg';
import paulandsharkLogo from './images/brand-logos/paulandshark.svg';
import californiacowboyLogo from './images/brand-logos/californiacowboy.svg';
import kerritsLogo from './images/brand-logos/kerrits.svg';
import shepherdsLogo from './images/brand-logos/shepherds.svg';
import saylorLogo from './images/brand-logos/saylor.svg';
import sofiaLogo from './images/brand-logos/sofia.svg';
import gauge81Logo from './images/brand-logos/gauge81.svg';
import onwardLogo from './images/brand-logos/onward.svg';

const brands = [
  {
    name: 'Galvan London',
    logo: galvanlondonLogo,
  },
  {
    name: 'Odlo',
    logo: odloLogo,
  },
  {
    name: 'Les Deux',
    logo: lesdeuxLogo,
  },
  {
    name: 'Holzweiler',
    logo: holzweilerLogo,
  },
  {
    name: 'Sea',
    logo: seaLogo,
  },
  {
    name: 'Malena Lingerie',
    logo: malenaLogo,
  },
  {
    name: 'Pas Normal Studios',
    logo: pasnormalLogo,
  },
  {
    name: 'Cycology',
    logo: cycologyLogo,
  },
  {
    name: "Bon'a Parte",
    logo: bonaparteLogo,
  },
  {
    name: 'Assos',
    logo: assosLogo,
  },
  {
    name: 'Paul & Shark',
    logo: paulandsharkLogo,
  },
  {
    name: 'California Cowboy',
    logo: californiacowboyLogo,
  },
  {
    name: 'Kerrits',
    logo: kerritsLogo,
  },
  {
    name: 'Shepherds',
    logo: shepherdsLogo,
  },
  {
    name: 'Saylor',
    logo: saylorLogo,
  },
  {
    name: 'Sofia',
    logo: sofiaLogo,
  },
  {
    name: 'Gauge81',
    logo: gauge81Logo,
  },
  {
    name: 'Onward Design Diversity',
    logo: onwardLogo,
  },
];

export default brands;
